var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState, useContext, createContext } from "react";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { AuthContext } from "./AuthContextProvider";
import { Box, CircularProgress } from "@mui/material";
import { ApolloProvider } from "@apollo/client";
import { useParams } from "react-router-dom";
import { SettingsContext } from "./SettingsContextProvider";
var defaultApolloContextValues = {
    apolloClient: null,
};
/**
 * Create the AuthContext using the default values.
 */
export var ApolloContext = createContext(defaultApolloContextValues);
export var ApolloContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), apolloClient = _b[0], setApolloClient = _b[1];
    var _c = useContext(AuthContext), isAuthenticated = _c.isAuthenticated, getAccessToken = _c.getAccessToken, login = _c.login;
    var _d = useParams(), tenantId = _d.tenantId, eventId = _d.eventId;
    var globalSettings = useContext(SettingsContext).globalSettings;
    useEffect(function () {
        if (!isAuthenticated && tenantId && eventId) {
            login(tenantId, eventId);
        }
    }, [isAuthenticated, tenantId, eventId]);
    var createApolloClient = function () {
        var httpLink = createHttpLink({
            uri: globalSettings.HASURA_URL,
        });
        var authLink = setContext(function (_, _a) {
            var headers = _a.headers;
            // get the authentication token from local storage if it exists
            var token = getAccessToken();
            // return the headers to the context so httpLink can read them
            return {
                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token) : "" }),
            };
        });
        var apolloClient = new ApolloClient({
            link: authLink.concat(httpLink),
            cache: new InMemoryCache(),
        });
        return apolloClient;
    };
    useEffect(function () {
        if (apolloClient || !isAuthenticated) {
            return;
        }
        var token = getAccessToken();
        if (!token) {
            return;
        }
        var newClient = createApolloClient();
        setApolloClient(newClient);
    }, [isAuthenticated, apolloClient]);
    // Setup the context provider
    return (_jsx(ApolloContext.Provider, __assign({ value: {
            apolloClient: apolloClient,
        } }, { children: children })));
};
export var ApolloWrapper = function (_a) {
    var children = _a.children;
    var apolloClient = useContext(ApolloContext).apolloClient;
    return (_jsx(_Fragment, { children: null === apolloClient ? (_jsx(Box, { children: _jsx(CircularProgress, {}) })) : (_jsx(ApolloProvider, __assign({ client: apolloClient }, { children: children }))) }));
};
